function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  d: "M22.927 59.746c-.99-.234-1.817-.783-2.976-1.971-1.935-1.986-3.506-2.812-6.236-3.282-2.831-.488-4.09-1.54-4.846-4.054-.934-3.104-1.91-4.59-4.055-6.174-2.433-1.797-3.057-3.381-2.463-6.253.55-2.66.34-4.55-.778-6.982-1.332-2.9-1.168-4.45.725-6.827 1.735-2.18 2.28-3.62 2.54-6.716.262-3.125 1.132-4.407 3.692-5.445 2.138-.866 3.966-2.37 4.98-4.094 1.172-1.995 1.343-2.223 2.069-2.765 1.172-.874 2.12-1.117 3.924-1.004 3.135.197 4.815-.18 6.92-1.55 2.745-1.787 4.409-1.787 7.154 0 2.105 1.37 3.785 1.747 6.92 1.55 2.964-.185 4.197.593 6.004 3.789.896 1.584 2.726 3.125 4.73 3.982 2.852 1.221 3.682 2.336 3.892 5.232.228 3.136.871 4.89 2.575 7.02 1.897 2.373 2.062 3.925.728 6.828-1.117 2.431-1.327 4.322-.777 6.982.593 2.872-.03 4.456-2.464 6.253-2.144 1.584-3.12 3.07-4.054 6.174-.757 2.514-2.015 3.566-4.847 4.054-2.735.47-4.308 1.3-6.235 3.288-2.137 2.204-3.67 2.567-6.657 1.58-2.443-.808-4.325-.811-6.759-.013-1.704.56-2.613.657-3.706.398Z",
  opacity: 0.2
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M22.927 59.16c-.99-.234-1.817-.783-2.976-1.971-1.935-1.986-3.506-2.812-6.236-3.282-2.831-.488-4.09-1.54-4.846-4.054-.934-3.104-1.91-4.59-4.055-6.174-2.433-1.797-3.057-3.381-2.463-6.253.55-2.66.34-4.55-.778-6.982-1.332-2.9-1.168-4.45.725-6.827 1.735-2.18 2.28-3.62 2.54-6.716.262-3.125 1.132-4.407 3.692-5.445 2.138-.866 3.966-2.37 4.98-4.094 1.172-1.995 1.343-2.223 2.069-2.765 1.172-.874 2.12-1.117 3.924-1.004 3.135.197 4.815-.18 6.92-1.55 2.745-1.787 4.409-1.787 7.154 0 2.105 1.37 3.785 1.747 6.92 1.55 2.964-.185 4.197.593 6.004 3.789.896 1.584 2.726 3.125 4.73 3.982 2.852 1.221 3.682 2.336 3.892 5.232.228 3.136.871 4.89 2.575 7.02 1.897 2.373 2.062 3.925.728 6.828-1.117 2.432-1.327 4.323-.777 6.982.593 2.872-.03 4.456-2.464 6.253-2.144 1.584-3.12 3.07-4.054 6.174-.757 2.514-2.015 3.566-4.847 4.054-2.735.47-4.308 1.3-6.235 3.288-2.137 2.204-3.67 2.567-6.657 1.58-2.443-.808-4.325-.811-6.759-.013-1.704.56-2.613.657-3.706.398Z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#034ECA",
  d: "M43.424 47.509a.731.731 0 0 1-1.34.569l-1.761-3.27a1.076 1.076 0 1 1 1.972-.837l1.129 3.538Z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#b)",
  d: "M43.424 47.509a.731.731 0 0 1-1.34.569l-1.761-3.27a1.076 1.076 0 1 1 1.972-.837l1.129 3.538Z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M42.048 35.775a6.204 6.204 0 0 0 1.69-1.636 6.252 6.252 0 0 0 .992-2.246l.013.002.74.14a1829.466 1829.466 0 0 0 1.24.233.58.58 0 0 0 .49-.14.567.567 0 0 0 .087-.745.57.57 0 0 0-.365-.239 359.59 359.59 0 0 0-.519-.097l-.721-.136-.74-.14-.08-.014.002-.062a6.232 6.232 0 0 0-.357-2.235l-.022-.06a6.241 6.241 0 0 0-1.137-1.941c.017-.02.033-.04.05-.058l.488-.572.476-.558.342-.401a.578.578 0 0 0 .135-.416.596.596 0 0 0-.049-.19.569.569 0 0 0-.567-.334.573.573 0 0 0-.39.198l-.342.401-.476.559-.488.571-.005.005a6.298 6.298 0 0 0-3.723-1.377 6.246 6.246 0 0 0-1.628.163l4.144 11.729c.247-.12.489-.254.72-.404Z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#4FAF53",
  d: "m48.373 33.769-4.42-12.526-7.047 2.487 4.42 12.525 7.047-2.486Z"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#d)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  fillOpacity: 0.3,
  d: "M44.17 29.065c-.438 1.55-1.767-1.91-4.157-2.584-2.39-.675-5.331 1.58-4.894.03.78-1.138 2.872-2.007 5.262-1.332 2.39.674 3.81 2.694 3.789 3.886Z"
}));

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#f)",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#g)",
  fillOpacity: 0.4,
  d: "M43.869 28.213c-1.314-.933-.177 2.595-1.614 4.62-1.438 2.025-5.143 2.116-3.83 3.049 1.322.395 3.496-.24 4.933-2.265 1.437-2.025 1.275-4.49.51-5.404Z"
}));

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#h)",
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fill: "#8BD8A0",
  d: "M38.761 23.716c-1.668.052-3.016.252-3.01.445.006.194 1.364.308 3.032.255 1.668-.052 3.998 1.338 3.992 1.144-.006-.193-2.346-1.897-4.014-1.844Z"
}));

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#i)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#8BD8A0",
  d: "M42.99 35.697c-1.333 1.006-2.507 1.696-2.624 1.542-.116-.155.869-1.095 2.2-2.102 1.332-1.006 2.274-3.55 2.39-3.396.117.155-.635 2.95-1.967 3.956Z"
}));

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#j)",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0D652D",
  d: "M43.605 24.693c-.61.746-.906 1.083-.972 1.03-.066-.055.124-.48.733-1.225.375-.935 1.49-.48 1.556-.426.066.054-.537-.443-1.317.621Z"
}));

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#k)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M42.517 25.66c.057.043.508-.451 1.007-1.105.5-.653.858-1.218.801-1.261-.057-.044-.508.45-1.007 1.104-.5.654-.858 1.218-.801 1.262Z"
}));

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#l)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.207 25.143c-.637.78-.924 1.152-.871 1.195.053.043.425-.259 1.062-1.04.916-.858-.034-1.489-.122-1.362-.26.277.845.174-.069 1.207Z"
}));

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#m)",
  fillOpacity: 0.9,
  d: "M43.915 23.421c-.276.198-.312.622-.08.947.234.326.646.43.923.231.276-.198.312-.622.08-.947-.234-.325-.646-.428-.923-.23Z",
  opacity: 0.15
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#n)",
  fillOpacity: 0.9,
  d: "M46.648 30.881c-.276.198-.312.622-.079.947.233.326.645.43.922.231.276-.197.312-.621.08-.947-.233-.325-.646-.428-.923-.23Z",
  opacity: 0.15
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#o)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M44.664 31.875c.016-.07.68.022 1.481.204.802.182 1.44.387 1.423.456-.016.07-.678-.021-1.48-.203-.802-.183-1.44-.387-1.424-.457Z"
}));

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  d: "M44.685 31.969c.075-.34.149-1.079.176-1.406l.727-.047-.09 2.084c-.302-.069-.888-.292-.813-.631Z"
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#0D652D",
  d: "M44.85 32.118c.036-.57.006-1.037-.065-1.042-.072-.004-.113.435-.148 1.006-.035.571-.05 1.059.022 1.063.071.004.157-.455.192-1.027Z"
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#81C995",
  d: "M44.888 30.961c.02-.162.01-.297-.022-.3-.032-.005-.054.12-.073.282-.019.163-.029.302.003.306.032.003.073-.125.092-.288Z"
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  d: "M42.368 25.576c.275.21.808.73 1.04.962l.585-.431-1.41-1.537c-.186.247-.491.794-.215 1.006Z"
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#0D652D",
  d: "M42.398 25.355c.395.415.672.79.62.84-.051.05-.366-.26-.76-.675-.394-.415-.72-.778-.667-.827.052-.05.413.247.807.662Z"
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#81C995",
  d: "M43.172 26.216c.119.112.198.222.176.245-.022.023-.118-.058-.237-.17-.12-.112-.217-.212-.195-.236.022-.023.137.05.256.161Z"
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#v)",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0D652D",
  d: "M46.147 32.003c-.947-.176-1.391-.242-1.407-.159-.015.084.404.286 1.35.462.89.472 1.448-.595 1.464-.68.016-.083-.125.687-1.407.377Z"
}));

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#w)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M46.311 31.245c-.963-.18-1.41-.277-1.396-.348.013-.07.48-.086 1.444.093 1.576.036 1.76 1.145.94 1.242-.36-.025.341-.798-.988-.987Z"
}));

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#x)",
  fillOpacity: 0.7,
  d: "M40.676 26.848c-.078.192-.057.384.05.427.105.043.255-.078.334-.27.078-.193.056-.384-.05-.428-.105-.043-.255.078-.334.27Z"
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#y)",
  fillOpacity: 0.7,
  d: "M42.527 32.114c-.182-.1-.285-.263-.23-.363.055-.1.248-.1.43 0s.285.263.23.363c-.055.1-.248.1-.43 0Z"
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#011B04",
  d: "M40.168 27.407c.5.022.707-.26.747-.404.293-.476-.182-.81-.404-.881-.222-.072-.598-.157-.955.181-.356.338-.013 1.076.612 1.104Z"
});

var _ref29 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#011B04",
  d: "M41.781 31.999c.373-.33.71-.24.831-.154.524.188.366.745.239.94-.127.195-.365.496-.853.456-.487-.04-.683-.83-.217-1.242Z"
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  d: "M41.859 33.096c.28.21.714.107.968-.23.254-.338.232-.782-.048-.993-.28-.21-.714-.107-.968.23-.254.338-.233.782.048.993Z"
});

var _ref31 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#B)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M40.132 27.302c.41.104.81-.08.894-.413.084-.332-.18-.685-.59-.788-.41-.104-.81.08-.894.413-.084.332.18.685.59.788Z"
}));

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#C)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M41.82 32.1c.253-.338.681-.445.955-.239.274.206.29.646.036.983-.254.338-.682.445-.956.24-.274-.206-.29-.647-.036-.984Z"
}));

var _ref33 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#202124",
  d: "M40.132 27.302c.41.104.81-.081.894-.413.084-.332-.18-.685-.59-.789-.41-.103-.81.082-.894.414-.084.332.18.685.59.788Z"
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  mask: "url(#D)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#E)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  fillOpacity: 0.29,
  d: "M40.481 26.173c-.333-.12-.643-.037-.762.034.231-.142.484-.21.802-.092a.898.898 0 0 1 .425.372c.018.03.032.054.04.072l-.04-.072a1.13 1.13 0 0 0-.034-.05c-.06-.077-.172-.171-.43-.264Z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#F)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#G)",
  d: "M40.754 27.148c.335-.217.268-.529.193-.658.094.101.103.339.031.466a.513.513 0 0 1-.224.192Z"
})));

var _ref35 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#202124",
  d: "M41.82 32.1c.254-.338.682-.445.956-.239.274.206.29.646.036.983-.254.338-.682.445-.956.24-.274-.206-.29-.647-.036-.984Z"
});

var _ref36 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  mask: "url(#H)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#I)",
  d: "M42.86 32.124a.466.466 0 0 0-.536-.294.517.517 0 0 1 .389.249c.106.185-.029.529-.11.677l.146.06a.681.681 0 0 0 .11-.692Z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#J)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  fillOpacity: 0.29,
  d: "M42.798 32.761c-.184.303-.477.433-.615.452.27-.035.508-.14.682-.431a.897.897 0 0 0 .097-.557.652.652 0 0 0-.014-.08c.003.023.01.049.014.08l.006.06c.002.098-.027.242-.17.476Z"
})));

var _ref37 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#K)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E2DCE1",
  d: "M40.68 26.417c-.069-.114-.23-.16-.302-.17l-.07.094a.57.57 0 0 1 .155.049c.066.032.145.087.177.11l.04-.083Z"
}));

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#L)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E2DCE1",
  d: "M42.801 32.452c.02.13-.072.264-.12.316l-.11-.03a.55.55 0 0 0 .086-.133c.03-.065.055-.156.064-.193l.08.04Z"
}));

var _ref39 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "#E2DCE1",
  filter: "url(#M)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.193 27.155a2.826 2.826 0 0 1-.158-.156h-.12a.53.53 0 0 0 .172.147l.106.01ZM40.723 27.175a.591.591 0 0 0 .079-.069l-.042.015a.496.496 0 0 1-.102.077c.01 0 .038-.005.065-.023Z"
}));

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "#E2DCE1",
  filter: "url(#N)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.952 32.171c-.012.07-.022.177-.025.221l-.093.075a.531.531 0 0 1 .041-.222l.077-.074ZM42.352 31.823a.597.597 0 0 1 .105.004l-.041.015a.487.487 0 0 0-.128.004.133.133 0 0 1 .064-.023Z"
}));

var _ref41 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#O)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#P)",
  fillOpacity: 0.4,
  d: "M43.092 33.947c-1.52.536.542-2.544-.284-4.886-.826-2.342-4.364-3.446-2.845-3.982 1.379-.018 3.294 1.19 4.12 3.532.827 2.341-.005 4.666-.99 5.336Z"
}));

var _ref42 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#Q)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#R)",
  fillOpacity: 0.4,
  d: "M43.092 33.947c-1.52.536.542-2.544-.284-4.886-.826-2.342-4.364-3.446-2.845-3.982 1.379-.018 3.294 1.19 4.12 3.532.827 2.341-.005 4.666-.99 5.336Z"
}));

var _ref43 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#4386F5",
  d: "M17.716 27.587a2.408 2.408 0 0 0-1.549-1.147 2.776 2.776 0 0 0-2.005.296c-.617.35-1.079.913-1.285 1.567-.206.653-.083 1.443.242 2.017l2.378-1.227 2.22-1.506Z"
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#S)",
  fillRule: "evenodd",
  d: "M17.695 27.552c3.44 5.696 10.644 8.134 16.94 5.444l2.102 4.917c-8.782 3.753-18.82.35-23.62-7.596l4.578-2.765Z",
  clipRule: "evenodd"
});

var _ref45 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#034ECA",
  d: "M16.689 47.509a.731.731 0 0 0 1.34.569l1.76-3.27a1.076 1.076 0 1 0-1.971-.837l-1.129 3.538Z"
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#T)",
  d: "M16.689 47.509a.731.731 0 0 0 1.34.569l1.76-3.27a1.076 1.076 0 1 0-1.971-.837l-1.129 3.538Z"
});

var _ref47 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#4285F4",
  d: "M25.674 16.685a3.027 3.027 0 1 1 5.689 2.071l-8.884 24.41a3.027 3.027 0 1 1-5.69-2.07l8.884-24.41Z"
});

var _ref48 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#U)",
  d: "M19.407 45.143a3.018 3.018 0 0 0 3.14-1.97l7.216-19.828a3.018 3.018 0 0 0-.785-3.247l-9.572 25.045Z"
});

var _ref49 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#4285F4",
  d: "M31.962 11.175a1.904 1.904 0 0 0-3.809 0v3.613a1.904 1.904 0 0 0 3.809 0v-3.613Z"
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#V)",
  d: "M31.962 11.175a1.904 1.904 0 0 0-3.809 0v3.613a1.904 1.904 0 0 0 3.809 0v-3.613Z"
});

var _ref51 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#W)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#044FCB",
  d: "M33.83 38.743c-.744.064.456-.857.273-2.999-.124-1.444.38-2.667 1.124-2.73.744-.064 1.448 1.055 1.572 2.5.617 2.313-2.224 3.166-2.968 3.23Z"
}));

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#X)",
  d: "M28.691 18.728a2.993 2.993 0 0 1 5.62-2.06l8.961 24.456a2.993 2.993 0 1 1-5.62 2.06l-8.96-24.456Z"
});

var _ref53 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#Y)",
  d: "M27.665 15.716a3.517 3.517 0 0 0-2.441 2.208l-8.422 23.129c-.514 1.41 0 2.934 1.097 3.618l9.766-28.955Z"
});

var _ref54 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#Z)",
  fillOpacity: 0.9,
  d: "M28.5 11.473c.426.427 1.195.35 1.718-.173.522-.522.6-1.292.173-1.719-.427-.426-1.196-.349-1.719.173-.522.523-.6 1.292-.173 1.719Z",
  opacity: 0.3
});

var _ref55 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#aa)",
  fillOpacity: 0.9,
  d: "M24.507 24.556c1.276.737 3.243-.28 4.393-2.272 1.15-1.992 1.048-4.204-.228-4.94-1.277-.738-3.243.28-4.393 2.272-1.15 1.992-1.048 4.204.228 4.94Z",
  opacity: 0.3
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M30.009 22.064a3.71 3.71 0 1 0 0-7.422 3.71 3.71 0 0 0 0 7.422Z"
});

var _ref57 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#202124",
  fillRule: "evenodd",
  d: "M30.009 15.618a2.734 2.734 0 1 0 0 5.47 2.734 2.734 0 0 0 0-5.47Zm-4.688 2.735a4.687 4.687 0 1 1 9.375 0 4.687 4.687 0 0 1-9.375 0Z",
  clipRule: "evenodd"
});

var _ref58 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "d",
  width: 9.563,
  height: 4.987,
  x: 34.841,
  y: 24.708,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.117
})), /*#__PURE__*/React.createElement("filter", {
  id: "f",
  width: 6.998,
  height: 8.636,
  x: 37.797,
  y: 27.708,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.176
})), /*#__PURE__*/React.createElement("filter", {
  id: "h",
  width: 7.375,
  height: 2.215,
  x: 35.575,
  y: 23.539,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.088
})), /*#__PURE__*/React.createElement("filter", {
  id: "i",
  width: 4.963,
  height: 5.877,
  x: 40.181,
  y: 31.559,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.088
})), /*#__PURE__*/React.createElement("filter", {
  id: "j",
  width: 2.775,
  height: 2.282,
  x: 42.386,
  y: 23.68,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.117
})), /*#__PURE__*/React.createElement("filter", {
  id: "k",
  width: 1.937,
  height: 2.488,
  x: 42.453,
  y: 23.233,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.029
})), /*#__PURE__*/React.createElement("filter", {
  id: "l",
  width: 1.815,
  height: 2.774,
  x: 43.154,
  y: 23.744,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.088
})), /*#__PURE__*/React.createElement("filter", {
  id: "o",
  width: 3.021,
  height: 0.824,
  x: 44.606,
  y: 31.793,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.029
})), /*#__PURE__*/React.createElement("filter", {
  id: "q",
  width: 0.492,
  height: 2.303,
  x: 44.491,
  y: 30.959,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.059
})), /*#__PURE__*/React.createElement("filter", {
  id: "r",
  width: 0.263,
  height: 0.729,
  x: 44.705,
  y: 30.59,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.035
})), /*#__PURE__*/React.createElement("filter", {
  id: "t",
  width: 1.673,
  height: 1.747,
  x: 41.468,
  y: 24.57,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.059
})), /*#__PURE__*/React.createElement("filter", {
  id: "u",
  width: 0.579,
  height: 0.555,
  x: 42.843,
  y: 25.981,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.035
})), /*#__PURE__*/React.createElement("filter", {
  id: "v",
  width: 3.283,
  height: 1.274,
  x: 44.506,
  y: 31.386,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.117
})), /*#__PURE__*/React.createElement("filter", {
  id: "w",
  width: 3.215,
  height: 1.735,
  x: 44.739,
  y: 30.672,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.088
})), /*#__PURE__*/React.createElement("filter", {
  id: "z",
  width: 1.666,
  height: 1.421,
  x: 39.377,
  y: 26.021,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.018
})), /*#__PURE__*/React.createElement("filter", {
  id: "A",
  width: 1.531,
  height: 1.551,
  x: 41.48,
  y: 31.73,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.018
})), /*#__PURE__*/React.createElement("filter", {
  id: "B",
  width: 1.539,
  height: 1.283,
  x: 39.508,
  y: 26.072,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.006,
  dy: 0.012
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.006
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0156863 0 0 0 0 0.231373 0 0 0 0 0.0666667 0 0 0 0.7 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1970_8019"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1970_8019",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "C",
  width: 1.376,
  height: 1.455,
  x: 41.621,
  y: 31.756,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.006,
  dy: 0.012
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.006
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0156863 0 0 0 0 0.231373 0 0 0 0 0.0666667 0 0 0 0.7 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1970_8019"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1970_8019",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "E",
  width: 1.291,
  height: 0.527,
  x: 39.707,
  y: 26.044,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.006
})), /*#__PURE__*/React.createElement("filter", {
  id: "F",
  width: 0.277,
  height: 0.663,
  x: 40.751,
  y: 26.487,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.001
})), /*#__PURE__*/React.createElement("filter", {
  id: "J",
  width: 0.81,
  height: 1.092,
  x: 42.171,
  y: 32.133,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.006
})), /*#__PURE__*/React.createElement("filter", {
  id: "K",
  width: 0.395,
  height: 0.276,
  x: 40.296,
  y: 26.236,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.006
})), /*#__PURE__*/React.createElement("filter", {
  id: "L",
  width: 0.256,
  height: 0.379,
  x: 42.559,
  y: 32.4,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.006
})), /*#__PURE__*/React.createElement("filter", {
  id: "M",
  width: 0.898,
  height: 0.211,
  x: 39.91,
  y: 26.993,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.003
})), /*#__PURE__*/React.createElement("filter", {
  id: "N",
  width: 0.635,
  height: 0.656,
  x: 41.828,
  y: 31.816,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.003
})), /*#__PURE__*/React.createElement("filter", {
  id: "O",
  width: 5.301,
  height: 9.398,
  x: 39.354,
  y: 24.844,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.117
})), /*#__PURE__*/React.createElement("filter", {
  id: "Q",
  width: 5.301,
  height: 9.398,
  x: 39.354,
  y: 24.844,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.117
})), /*#__PURE__*/React.createElement("filter", {
  id: "W",
  width: 3.887,
  height: 6.322,
  x: 33.292,
  y: 32.718,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_1970_8019",
  stdDeviation: 0.146
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 42.948,
  x2: 41.02,
  y1: 48.281,
  y2: 47.187,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4285F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#034ECA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 40.404,
  x2: 39.793,
  y1: 25.095,
  y2: 27.261,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8F0B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ADEEBC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 43.428,
  x2: 41.593,
  y1: 33.666,
  y2: 32.364,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8F0B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ADEEBC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "G",
  x1: 41.106,
  x2: 40.595,
  y1: 26.476,
  y2: 26.682,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2DDE2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2DDE2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "I",
  x1: 42.888,
  x2: 42.46,
  y1: 32.199,
  y2: 32.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#373637"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#373637",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "P",
  x1: 44.165,
  x2: 42.043,
  y1: 28.582,
  y2: 29.331,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8F0B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ADEEBC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "R",
  x1: 44.165,
  x2: 42.043,
  y1: 28.582,
  y2: 29.331,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8F0B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ADEEBC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "S",
  x1: 28.105,
  x2: 37.382,
  y1: 35.54,
  y2: 34.808,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4285F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.703,
  stopColor: "#044FCB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "T",
  x1: 17.509,
  x2: 19.509,
  y1: 47.792,
  y2: 46.612,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4285F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#034ECA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "U",
  x1: 26.686,
  x2: 25.62,
  y1: 31,
  y2: 30.63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#73A7FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5893F6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "V",
  x1: 30.058,
  x2: 31.734,
  y1: 11.401,
  y2: 12.909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4285F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#034ECA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "X",
  x1: 31.933,
  x2: 37.002,
  y1: 21.266,
  y2: 31.86,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#034DC9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4285F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Y",
  x1: 19.667,
  x2: 22.337,
  y1: 29.995,
  y2: 30.912,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9BC0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5893F6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "m",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.26822 -.36786 .26657 -.19436 44.337 24.01)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.948,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "n",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-126.097 31.536 3.769) scale(.45526 .3299)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.948,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "x",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-156.205 23.27 9.157) scale(.17761 .3235)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93E19F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#93E19F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "y",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0815 .15773 -.28727 -.14844 42.627 31.933)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93E19F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#93E19F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Z",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.58937 .5997 -.4178 -.4106 29.445 10.527)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.948,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "aa",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(119.61 7.2 18.211) scale(2.61787 1.43021)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.948,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "#fff",
  rx: 2.344
})));

var SvgAndroidStudio = function SvgAndroidStudio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 11,
    height: 14,
    x: 37,
    y: 23,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ref6), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    width: 2,
    height: 3,
    x: 44,
    y: 30,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ref18), /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#q)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref19), /*#__PURE__*/React.createElement("g", {
    filter: "url(#r)",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }, _ref20)), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    width: 2,
    height: 3,
    x: 42,
    y: 24,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ref21), /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref22), /*#__PURE__*/React.createElement("g", {
    filter: "url(#u)",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }, _ref23)), _ref24, _ref25), _ref26, _ref27, /*#__PURE__*/React.createElement("g", {
    filter: "url(#z)",
    opacity: 0.09,
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref28), /*#__PURE__*/React.createElement("g", {
    filter: "url(#A)",
    opacity: 0.09,
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref29), _ref30, _ref31, _ref32, /*#__PURE__*/React.createElement("mask", {
    id: "D",
    width: 3,
    height: 2,
    x: 39,
    y: 26,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ref33), _ref34, /*#__PURE__*/React.createElement("mask", {
    id: "H",
    width: 2,
    height: 3,
    x: 41,
    y: 31,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ref35), _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57), _ref58);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAndroidStudio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "android-studio.svg";
export { ForwardRef as ReactComponent };